/**
 * @fileoverview User Management query keys.
 * @description Every User Management query sits under the `['users']` prefix, so invalidating it
 * (after an invitation, an update, a deactivation or a reactivation) refreshes the directory, its
 * summary, its filter options and any open user's details together. The user-invitations feature
 * invalidates the same prefix.
 * @copyright Copyright (c) 2026 Brownbox Consulting. All rights reserved.
 * @author Rahul Chawda
 * @author Anshul Rokde
 */

export const USERS_QUERY_KEY = ['users'] as const

export const USERS_QUERY_KEYS = {
  directory: [...USERS_QUERY_KEY, 'directory'] as const,
  summary: [...USERS_QUERY_KEY, 'summary'] as const,
  filterOptions: [...USERS_QUERY_KEY, 'filter-options'] as const,
  directReports: [...USERS_QUERY_KEY, 'direct-reports'] as const,
  myTeam: [...USERS_QUERY_KEY, 'my-team'] as const,
  myTeamSummary: [...USERS_QUERY_KEY, 'my-team', 'summary'] as const,
  details: [...USERS_QUERY_KEY, 'detail'] as const,
  detail: (userId: string) => [...USERS_QUERY_KEY, 'detail', userId] as const,
  allEditOptions: [...USERS_QUERY_KEY, 'edit-options'] as const,
  editOptions: (userId: string) => [...USERS_QUERY_KEY, 'edit-options', userId] as const,
  configuration: [...USERS_QUERY_KEY, 'configuration'] as const,
}
